import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Assemble the object-toolbar config for the Automations register/list page
 * (CUS-136). Register toolbars are type-level: no `parentObject` (permissions
 * resolve against the type) and no `save` (a list page has no form).
 *
 * Automations is an integrations landing page — a static grid of integration
 * cards, not a data table. It has no create action, no multi-format export, and
 * no `CustomisableRibbon`, so its toolbar is title-only (the shared
 * {@link RegisterToolbarConfigArgs}' `exportOptions` is inapplicable here and
 * left unused). The migration exists to give the register the flag-gated toolbar
 * header it previously lacked.
 *
 * Takes the shared {@link RegisterToolbarConfigArgs} (see
 * `blocks/object-toolbar/types.ts`). Pure so it can be unit-tested without
 * rendering the page.
 */
export const buildAutomationsRegisterToolbarConfig = ({
  title,
  counter,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
});
